// extracted by mini-css-extract-plugin
export var text = "_ay-0";